<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Daftar : Agensi Pembayar">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitAgensi"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>

                <w-dialog
                    v-model="dialog.show"
                    :fullscreen="dialog.fullscreen"
                    :width="dialog.width"
                    :persistent="dialog.persistent"
                    :persistent-no-animation="dialog.persistentNoAnimation"
                    title-class="primary-light1--bg white"
                >
                    <template #title> Tambah Agensi </template>
                    <template #default>
                        <w-form
                            ref="form"
                            v-model="dialog.valid"
                            @validate="submitJabatan"
                            @success="success"
                        >
                            
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                    label="Kod *"
                                    name="Kod *"
                                    v-model="form_jabatan.kod"
                                    :validators="[validators.required]"
                                />&nbsp;&nbsp;&nbsp;
                                <z-input
                                    label="Nama*"
                                    name="Nama*"
                                    v-model="form_jabatan.nama"
                                    :validators="[validators.required]"
                                />
                            </w-flex>
                        </w-form>
                    </template>
                    <template #actions>
                        <div class="spacer" />
                        <w-button
                            bg-color="grey-light5--bg"
                            @click="dialog.show = false"
                            >Tutup</w-button
                        >
                        <w-button
                            class="ml1"
                            :loading="dialog.loading"
                            :disabled="dialog.valid === false"
                            @click="$refs.form.validate()"
                            >Daftar</w-button
                        >
                    </template>
                </w-dialog>

                <w-card bg-color="" class="">
                    <h3>Agensi</h3>
                    <w-flex class="mt3">
                        <div class="xs11">
                            <z-input
                                label="Kod | Nama "
                                name="perumahan_jabatan"
                                readonly
                                @click="agensi"
                                :validators="[validators.required]"
                            />
                        </div>
                        <div class="xs1">
                            <w-icon>fal fa-search</w-icon>
                            &nbsp;
                            <w-icon @click="dialog.show = true"
                                >fal fa-plus</w-icon
                            >
                        </div>
                    </w-flex>
                    <br />

                    <w-flex v-if="form.nama">
                    <div class="xs6">
                      <h5 class="fw-semibold m0">
                          Agensi :
                      </h5>
                      {{form.kod}} | {{form.nama}}
                    </div>

              </w-flex> </w-card
                ><br />

                <!-- </w-from> -->
                <w-card bg-color="" class="">
                    <h3>Butiran</h3>
                    <w-flex class="mt3">
                        <div class="xs6">
                            <z-input
                                label="Kod Jabatan *"
                                v-model="form.kod_pejabat"
                                :validators="[validators.required]"
                            />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6">
                            <z-input
                                label="Nama Jabatan *"
                                v-model="form.nama_pejabat"
                                :validators="[validators.required]"
                            />
                        </div>
                    </w-flex>

                    <w-flex class="mt3">
                        <z-input
                                label="No Telefon"
                                v-model="form.no_tel"
                                :validators="[validators.required]"
                            />
                        &nbsp;&nbsp;&nbsp;
                        <z-input
                                label="Emel"
                                v-model="form.emel"
                                :validators="[validators.required]"
                            />
                    </w-flex>

                    <w-flex class="mt3">
                        <z-input
                                label="Alamat"
                                v-model="form.alamat1"
                                :validators="[validators.required]"
                            />
                    </w-flex>
                    <w-flex class="mt3">
                        <div class="xs6">
                        <z-input
                                v-model="form.alamat2"
                                :validators="[validators.required]"
                            />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6 ">
                        <z-input
                                v-model="form.alamat3"
                                :validators="[validators.required]"
                            />
                        </div>
                    </w-flex>
                    <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                                label="Poskod"
                                :url="service_utiliti + 'lookup/lkp_poskod'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_poskod_id"
                                :validators="[validators.required]"
                            />
                        </div>
                    </w-flex>
                    <br>
                    <w-flex class="mt3">
                       <!--  <div class="xs6">
                        <z-lookup
                                label="Bandar"
                                :url="service_utiliti + 'lookup/lkp_bandar'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_bandar_id"
                                :validators="[validators.required]"
                            />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div class="xs6 ">
                        <z-lookup
                                label="Negri"
                                :url="service_utiliti + 'lookup/lkp_negeri'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_negeri_id"
                                :validators="[validators.required]"
                            /> -->
                        <!-- </div> -->
                             <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form.bandar}}</td>
                                  </tr>
                              </div>
                              <div class="xs6">
                                <tr >
                                    <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                    <td>{{form.negeri}}</td>
                                  </tr>
                              </div>
                    </w-flex>
                    <br>

                </w-card>

                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="tutup"
                    >
                        Kembali
                    </w-button>
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="clear()"
                    >
                        Reset
                    </w-button>
                            &nbsp;&nbsp;&nbsp;
                            <w-button
                                class="my1"
                                type="submit"
                                :disabled="form.valid === false"
                                :loading="form.submitted && !form.sent"
                            >
                                <w-icon dark tile class="mr2">fal fa-save</w-icon>
                                Simpan
                            </w-button>
                </w-flex>
            </w-form>
            <w-dialog
                v-model="dialogAgensi.show"
                :fullscreen="dialogAgensi.fullscreen"
                :width="dialogAgensi.width"
                :persistent="dialogAgensi.persistent"
                :persistent-no-animation="dialogAgensi.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Agensi
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama"
                                v-model="carian_jabatan.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariJabatan"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Kod | Nama
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in jabatans">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            v-model="form.perumahan_jabatan"
                                            :return-value="dt.value"
                                            @click="pilihJabatan(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogAgensi.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>
            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
// import moment from 'moment'

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_tunggakan + "perumahan_agensi/agensi",
            reload: true,
            form_jabatan: {},
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],
            form_cari: {},
            form_akaun: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Perumahan", route: "/perumahan" },
                { label: "Agensi Pembayar", route: "/perumahan/agensi" },
                { label: "Daftar", route: "/perumahan/agensi/daftar" },
            ],
            files: [],
            carian_profil: { q: "" },
            carian_jabatan: { q: "" },
            profils: [],
            jabatans: [],
            dialogAgensi: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                no_tel: "",
                amaun_deposit: 0.0,
            },
            validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        agensi() {
            this.dialogAgensi.show = 1;
        },
        // profil() {
        //     this.dialogProfil.show = 1;
        // },
        clear () {
            this.getData()
            this.files = false
            this.form.nama = false
            this.$nextTick(() => {
                this.form.nama = true
                this.files = true
            })
        },

        poskodDetail() {
      
        this.$zcomm.get(this.service_utiliti+'lookup/lkp_poskod_detail/'+this.form.lkp_poskod_id).then(res => {
                  this.form.negeri = res.negeri;
                  this.form.lkp_negeri_id = res.lkp_negeri_id;
                  this.form.bandar = res.bandar;
                  this.form.lkp_jenis_alamat_id = 1;
                });
        },


        cariJabatan() {
            if (this.carian_jabatan.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/perumahan_jabatan",
                        this.carian_jabatan,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.jabatans = res;
                    });
            }
        },

        pilihJabatan(dt) {
            this.form.perumahan_jabatan_keterangan = dt.label;
            this.form_cari.id = dt.value;
            this.jabatanDetail();
        },
        jabatanDetail() {
            this.$zcomm
                .get(this.service_tunggakan + "perumahanJabatan/" + this.form_cari.id)
                .then((res) => {
                    this.form.perumahan_jabatan_id = res.id;
                    this.form.kod = res.kod;
                    this.form.nama = res.nama;
                    this.dialogAgensi.show = false;
                });
        },
        submitAgensi() {
            // alert(t)
            this.$zcomm
                .post(this.resourceurl, this.form)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya Daftar");
                    this.$inertia.visit(this.$route('perumahan-agensi.agensi.index'))
                })
                .catch((err) => {})
                .finally(() => {
                    // <inertia-link :href='$route("deposit.show",item.id)'>
                });
        },


        submitJabatan() {
            // if (this.$refs.form.validate()) {
            this.dialog.loading = true;

            this.$zcomm
                .post(this.service_tunggakan + "perumahanJabatan", this.form_jabatan)
                .then((res) => {
                    // console.log(res)
                    //update displayed record
                    // this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.form.perumahan_jabatan_id = res.id;
                    this.form.nama = res.nama;
                    this.form.kod = res.kod;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialog.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                });

            // }
        },
        tutup(){
                this.$inertia.visit(window.route('perumahan-agensi.agensi.index'));
        },
    },
    watch: {
        files: function (val) {
            // console.log(val);
            console.log("work");
        },
        "form.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.jabatanDetail();
            // this.profilDetail();
        },
        "form_akaun.id": function (q) {
            this.akaunDetail();
        },
    },
    mounted() {
        this.dialog.width = 900;
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
